import { Collection } from 'modules/core/lib/mobx-rest'

import MedicalLeaveUpdate from 'modules/timeoff/store/models/MedicalLeaveUpdate'

class MedicalLeaveUpdates extends Collection<MedicalLeaveUpdate> {
  get cacheKey(): string {
    return 'medicalLeaveUpdates'
  }

  model() {
    return MedicalLeaveUpdate
  }
}

const singleton: MedicalLeaveUpdates = new MedicalLeaveUpdates()

export default singleton
